import { Injectable } from '@angular/core';
import { RemoteData } from '@common/util-models';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ImeiState } from './imei.reducer';
import * as ImeiSelectors from './imei.selectors';
import * as ImeiActions from './imei.actions';

@Injectable()
export class ImeiFacade {
  imeiLoaded$: Observable<RemoteData> = this.store.pipe(
    select(ImeiSelectors.getImeiLoaded)
  );

  isImeiInvalid$: Observable<boolean> = this.store.pipe(
    select(ImeiSelectors.isImeiInvalid)
  );

  imeiBrand$: Observable<string | undefined> = this.store.pipe(
    select(ImeiSelectors.getImeiBrand)
  );

  imeiModel$: Observable<string | undefined> = this.store.pipe(
    select(ImeiSelectors.getImeiModel)
  );

  imeiNumber$: Observable<string | undefined> = this.store.pipe(
    select(ImeiSelectors.getImeiNumber)
  );

  constructor(private store: Store<ImeiState>) {}

  loadImei(imei: string) {
    this.store.dispatch(ImeiActions.loadImei({ imei }));
  }

  resetImei() {
    this.store.dispatch(ImeiActions.resetImei());
  }
}
